export default __webpack_public_path__ + "static/media/plus-grey.278c32c9.svg";